import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class GuidancePlanningPeriod extends BaseEntity {
  guidanceId?: number;
  year?: number;
  planningType?: string;
  startMonth?: number;
  granularity?: string;
}
